import { Breadcrumb, Col, Row, Typography } from "antd";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { translate } from "../../../locale";
import FormSubscription from "./FormSubscription";
import { useParams } from "react-router-dom";

const { Title } = Typography;

const AddSubscription = () => {
  const { company_id } = useParams();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {}, []);
  return (
    <div className="flex flex-col min-h-full w-screen max-w-7xl pb-16 m-10">
      <Row>
        <Col className="gutter-row" span="24">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/admin">{translate("Inicio")}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/admin/subscriptions">
                {translate("Suscripciones")}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              {translate("Agregar suscripción")}
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col span="24" className="my-4">
          <Title level={2} className="text-center">
            {translate("Configuración de suscripción")}
          </Title>
          <div className="flex flex-col justify-center items-center w-full my-8 bg-gray-200">
            <Title level={4} className="my-4 uppercase">
              {translate("Información general")}
            </Title>
          </div>
          <div className="px-6">
            <FormSubscription type={"add"} enterprise_id={company_id} />
          </div>
          {/* <div className="flex flex-col justify-center items-center w-full my-16 bg-gray-200">
            <Title level={4} className="my-4 uppercase">
              {translate("Protocolos")}
            </Title>
          </div>
          <Row gutter={16}>
            <Col span="24">
              <SecondaryButton onClick={connectProtocol} className="mb-4">
                {translate("Conectar protocolo")}
              </SecondaryButton>
            </Col>
          </Row>
          <div className="flex flex-col justify-center items-center w-full my-16 bg-gray-200">
            <Title level={4} className="my-4 uppercase">
              {translate("Módulos")}
            </Title>
          </div>
          <Row gutter={16}>
            <Col span="24">
              <SecondaryButton onClick={() => navigate('/admin/subscriptions/modules')} className="mb-4">
                {translate("Agregar módulos")}
              </SecondaryButton>
            </Col>
          </Row>
          <div className="flex flex-col justify-center items-center w-full my-16 bg-gray-200">
            <Title level={4} className="my-4 uppercase">
              {translate("Instituciones")}
            </Title>
          </div>
          <div className="flex flex-col justify-center items-center w-full my-16 bg-gray-200">
            <Title level={4} className="my-4 uppercase">
              {translate("Profesionales")}
            </Title>
          </div>
          <div className="flex flex-col justify-center items-center w-full my-16 bg-gray-200">
            <Title level={4} className="my-4 uppercase">
              {translate("Usuarios")}
            </Title>
          </div> */}
        </Col>
      </Row>
    </div>
  );
};

export default AddSubscription;
